// Google Analytics 4 유틸리티 함수들

export const GA_TRACKING_ID = 'G-Q7MYJW9HFR';

// gtag 함수가 로드되었는지 확인하는 헬퍼 함수
const isGtagLoaded = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// Google Analytics가 로드될 때까지 기다리는 함수
const waitForGtag = (timeout = 5000) => {
  return new Promise((resolve) => {
    if (isGtagLoaded()) {
      resolve(true);
      return;
    }

    const startTime = Date.now();
    const checkInterval = setInterval(() => {
      if (isGtagLoaded()) {
        clearInterval(checkInterval);
        resolve(true);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(checkInterval);
        console.warn('Google Analytics failed to load within timeout');
        resolve(false);
      }
    }, 100);
  });
};

// 페이지뷰 추적
export const pageview = (url) => {
  if (isGtagLoaded()) {
    try {
      window.gtag('config', GA_TRACKING_ID, {
        page_location: url,
      });
    } catch (error) {
      console.warn('Google Analytics pageview tracking failed:', error);
    }
  }
};

// 커스텀 이벤트 추적
export const event = ({ action, category, label, value }) => {
  if (isGtagLoaded()) {
    try {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    } catch (error) {
      console.warn('Google Analytics event tracking failed:', error);
    }
  }
};

// 비디오 분석 시작 이벤트
export const trackVideoAnalysis = (videoUrl, videoTitle) => {
  try {
    event({
      action: 'video_analysis_start',
      category: 'engagement',
      label: videoTitle || videoUrl,
    });
  } catch (error) {
    console.warn('trackVideoAnalysis failed:', error);
  }
};

// 비디오 분석 완료 이벤트
export const trackVideoAnalysisComplete = (videoUrl, videoTitle, duration) => {
  try {
    event({
      action: 'video_analysis_complete',
      category: 'engagement',
      label: videoTitle || videoUrl,
      value: duration,
    });
  } catch (error) {
    console.warn('trackVideoAnalysisComplete failed:', error);
  }
};

// QA 질문 이벤트
export const trackQAQuestion = (question, videoTitle) => {
  try {
    event({
      action: 'qa_question',
      category: 'engagement',
      label: videoTitle,
    });
  } catch (error) {
    console.warn('trackQAQuestion failed:', error);
  }
};

// 로그인 이벤트
export const trackLogin = (method) => {
  try {
    // Google Analytics가 로드되지 않았더라도 에러를 방지
    if (isGtagLoaded()) {
      event({
        action: 'login',
        category: 'user',
        label: method, // 'google', 'email', 'kakao'
      });
    } else {
      console.log('Google Analytics not loaded yet, skipping trackLogin for:', method);
    }
  } catch (error) {
    console.warn('trackLogin failed:', error);
  }
};

// 회원가입 이벤트
export const trackSignup = (method) => {
  try {
    if (isGtagLoaded()) {
      event({
        action: 'sign_up',
        category: 'user',
        label: method,
      });
    } else {
      console.log('Google Analytics not loaded yet, skipping trackSignup for:', method);
    }
  } catch (error) {
    console.warn('trackSignup failed:', error);
  }
};

// 에러 이벤트
export const trackError = (errorType, errorMessage) => {
  try {
    event({
      action: 'error',
      category: 'error',
      label: `${errorType}: ${errorMessage}`,
    });
  } catch (error) {
    console.warn('trackError failed:', error);
  }
}; 